/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/audit-reports-api-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/audit-reports-api-client";
import type { ExecuteGipAltReportMutationRequest, ExecuteGipAltReportMutationResponse, ExecuteGipAltReportQueryParams, ExecuteGipAltReport400, ExecuteGipAltReport500 } from "../models/ExecuteGipAltReport";

export function getExecuteGipAltReportUrl() {
  const res = { method: 'POST', url: `/reports/gip-alt/results` as const }
  return res
}

/**
 * @summary Generate report results
 * {@link /reports/gip-alt/results}
 */
export async function executeGipAltReport(data: ExecuteGipAltReportMutationRequest, params?: ExecuteGipAltReportQueryParams, config: Partial<RequestConfig<ExecuteGipAltReportMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<ExecuteGipAltReportMutationResponse, ResponseErrorConfig<ExecuteGipAltReport400 | ExecuteGipAltReport500>, ExecuteGipAltReportMutationRequest>({ method : "POST", url : getExecuteGipAltReportUrl().url.toString(), params, data : requestData, ... requestConfig })
  return res.data
}